<div
  class="input-organisation"
  [class.input-organisation--invalid]="control().touched && !control().valid"
>
  @if (label()) {
    <div class="input-organisation__label">
      @if (hasPermissions()) {
        <mat-icon
          class="input-organisation__hint"
          matTooltip="You can only select organisation units which you are assigned to."
        >
          info
        </mat-icon>
      }
      {{ label() }}
      @if (!showMode() && isRequired) {
        <span class="input-required"> * </span>
      }
    </div>
  }
  <procure-loading-indicator [active]="isLoading()" />
  <div class="input-organisation__items">
    @for (businessArea of organisationLookup()?.businessAreas; track businessArea.id) {
      <div class="input-organisation__item">
        <div class="input-organisation__item-detail">
          <mat-icon
            class="input-organisation__toggle"
            [class.input-organisation__toggle--disabled]="!businessArea.divisions?.length"
            (click)="toggleExpansion(businessArea)"
          >
            {{ (expanded() | contains: businessArea.id) ? "expand_more" : "chevron_right" }}
          </mat-icon>
          <div class="input-organisation__item-label">
            {{ businessArea.getDisplay() }}
            @let businessAreaSelection = selectedDescendants(businessArea);
            @if (businessAreaSelection.total) {
              <procure-number-badge
                small
                [matTooltip]="getSelectedTooltip(businessAreaSelection)"
                [value]="businessAreaSelection.total"
                [clickable]="false"
              />
            }
          </div>
        </div>
        @if (expanded() | contains: businessArea.id) {
          @for (division of businessArea.divisions; track division.id) {
            <div class="input-organisation__item">
              <div class="input-organisation__item-detail">
                <mat-icon
                  class="input-organisation__toggle"
                  [class.input-organisation__toggle--disabled]="!division.hubs?.length"
                  (click)="toggleExpansion(division)"
                >
                  {{ (expanded() | contains: division.id) ? "expand_more" : "chevron_right" }}
                </mat-icon>
                @if (!onlyLocalDivision()) {
                  <procure-input-check
                    [control]="form.controls.divisions.controls[division.id]"
                    [showMode]="showMode()"
                    (valueChange)="toggleItem($event, division)"
                  >
                    <ng-container *ngTemplateOutlet="divisionLabelTemplate; context: { division }" />
                  </procure-input-check>
                } @else {
                  <div class="input-organisation__item-label">
                    <ng-container *ngTemplateOutlet="divisionLabelTemplate; context: { division }" />
                  </div>
                }
                <ng-template
                  #divisionLabelTemplate
                  let-division="division"
                >
                  {{ division.getDisplay() }}
                  @let divisionSelection = selectedDescendants(division);
                  @if (divisionSelection.total) {
                    <procure-number-badge
                      small
                      [matTooltip]="getSelectedTooltip(divisionSelection)"
                      [value]="divisionSelection.total"
                      [clickable]="false"
                    />
                  }
                </ng-template>
              </div>
              @if (expanded() | contains: division.id) {
                @for (hub of division.hubs; track hub.id) {
                  <div class="input-organisation__item">
                    <div class="input-organisation__item-detail">
                      <mat-icon
                        class="input-organisation__toggle"
                        [class.input-organisation__toggle--disabled]="!hub.localDivisions?.length"
                        (click)="toggleExpansion(hub)"
                      >
                        {{ (expanded() | contains: hub.id) ? "expand_more" : "chevron_right" }}
                      </mat-icon>
                      @if (!onlyLocalDivision()) {
                        <procure-input-check
                          [control]="form.controls.hubs.controls[hub.id]"
                          [showMode]="showMode()"
                          (valueChange)="toggleItem($event, hub)"
                        >
                          <ng-container *ngTemplateOutlet="hubLabelTemplate; context: { hub }" />
                        </procure-input-check>
                      } @else {
                        <div class="input-organisation__item-label">
                          <ng-container *ngTemplateOutlet="hubLabelTemplate; context: { hub }" />
                        </div>
                      }
                      <ng-template
                        #hubLabelTemplate
                        let-hub="hub"
                      >
                        {{ hub.getDisplay() }}
                        @let hubSelection = selectedDescendants(hub);
                        @if (hubSelection.total) {
                          <procure-number-badge
                            small
                            [matTooltip]="getSelectedTooltip(hubSelection)"
                            [value]="hubSelection.total"
                            [clickable]="false"
                          />
                        }
                      </ng-template>
                    </div>
                    @if (expanded() | contains: hub.id) {
                      @for (localDivision of hub.localDivisions; track localDivision.id) {
                        <div class="input-organisation__item">
                          <div class="input-organisation__item-detail input-organisation__item-detail--static">
                            <procure-input-check
                              [control]="form.controls.localDivisions.controls[localDivision.id]"
                              [showMode]="showMode()"
                              (valueChange)="toggleItem($event, localDivision)"
                            >
                              {{ localDivision.getDisplay() }}
                            </procure-input-check>
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
              }
            </div>
          }
        }
      </div>
    }
  </div>
</div>
